module.exports = __webpack_public_path__ + "img/good.ea5f7e68.svg";